var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _vm.viewName == "MC"
      ? _c("div", { staticClass: "contents_wrap" }, [
          _c("h2", { staticClass: "pg_title" }, [
            _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.RESULTS")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "srchTop_wrap srch_result mb-20" }, [
            _c("article", { staticClass: "srch_basic clear" }, [
              _c("dl", { staticClass: "dl_search w100p" }, [
                _c(
                  "dd",
                  {
                    staticClass: "clearable",
                    attrs: { "data-input-type": "input" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modelCode,
                          expression: "modelCode"
                        }
                      ],
                      ref: "modelCd",
                      staticClass: "text_input w100p",
                      attrs: {
                        type: "text",
                        placeholder: _vm.placeHolder,
                        maxLength: "20"
                      },
                      domProps: { value: _vm.modelCode },
                      on: {
                        keyup: [
                          _vm.onAutoCmpl,
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.onSearch(1)
                          }
                        ],
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.modelCode = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "clearable_clear" }, [_vm._v("X")])
                  ]
                ),
                _vm._v(" "),
                _c("dd", { staticClass: "btn" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_srch",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.onSearch(1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                  )
                ]),
                _vm._v(" "),
                _vm.searchMode == "1"
                  ? _c("dd", { staticClass: "auto" }, [
                      _c("article", { staticClass: "srch_more" }, [
                        _c("dl", { staticClass: "srch_autocomplete" }, [
                          _c("dd", [
                            _c(
                              "ul",
                              { staticClass: "scroll" },
                              _vm._l(_vm.autoCompletes, function(model) {
                                return _c(
                                  "li",
                                  {
                                    key: model.ID,
                                    class: { active: model.ID == _vm.modelCode }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "JavaScript:" },
                                        on: {
                                          click: function($event) {
                                            _vm.modelCode = model.ID
                                            _vm.searchMode = "0"
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(model.LABEL))]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result_wrap" }, [
            _c("p", { staticClass: "refine" }, [
              _c("em", [_vm._v(_vm._s(_vm.$t("TITLE.SEARCH.RESULT.FOR")))]),
              _vm._v(" '" + _vm._s(_vm.modelCode) + "'")
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "active", attrs: { "data-type": "quick" } },
              [
                _c("div", { staticClass: "result_title" }, [
                  _c("em", [
                    _vm._v(_vm._s(_vm.$t("TITLE.SEARCH.QUICK.DOWNLOAD")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "result_con" }, [
                  _vm.quickDownloads.length > 0
                    ? _c(
                        "div",
                        { staticClass: "table_modul table_scroll pc_only" },
                        [
                          _c("table", { staticClass: "data_table_ty2" }, [
                            _c(
                              "colgroup",
                              [
                                _c("col", { attrs: { width: "155px" } }),
                                _vm._v(" "),
                                _vm._l(_vm.columns, function(col) {
                                  return _c("col", {
                                    key: col.boardId,
                                    attrs: { width: "140px" }
                                  })
                                }),
                                _vm._v(" "),
                                _c("col", { attrs: { width: "140px" } })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("thead", [
                              _c(
                                "tr",
                                [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.$t("FIELD.SEARCH.MODELS"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.columns, function(col) {
                                    return _c(
                                      "th",
                                      {
                                        key: col.boardId,
                                        attrs: { align: "center" }
                                      },
                                      [_vm._v(_vm._s(col.headerNm))]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.BOM")))
                                  ])
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.quickDownloads, function(data) {
                                return _c(
                                  "tr",
                                  { key: data.BMODEL_ID },
                                  [
                                    _c("td", { staticClass: "text_center" }, [
                                      _c(
                                        "a",
                                        { attrs: { href: "JavaScript:" } },
                                        [
                                          _c(
                                            "em",
                                            {
                                              staticClass: "txt_point",
                                              on: {
                                                click: function($event) {
                                                  return _vm.clickQcModel(
                                                    data.BMODEL_ID
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(data.BMODEL_ID))]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(data.subValues, function(sub) {
                                      return _c(
                                        "td",
                                        {
                                          key: sub.ID,
                                          staticClass: "text_center"
                                        },
                                        [
                                          sub.headId == "CNT_EXPVP"
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "JavaScript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.viewAttachFiles(
                                                        $event,
                                                        data
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "em",
                                                    {
                                                      staticClass: "txt_point"
                                                    },
                                                    [_vm._v(_vm._s(sub.cntSum))]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          sub.headId != "CNT_EXPVP" &&
                                          sub.cntSum > 0
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "JavaScript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.fileDownload(
                                                        sub.nIndex,
                                                        data
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "em",
                                                    {
                                                      staticClass: "txt_point"
                                                    },
                                                    [_vm._v(_vm._s(sub.cntSum))]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          sub.headId != "CNT_EXPVP" &&
                                          sub.cntSum == 0
                                            ? _c("span", [
                                                _vm._v(_vm._s(sub.cntSum))
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text_center" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "ico_attach",
                                          attrs: { href: "JavaScript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.popupBomOpen(data)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "sr_only" },
                                            [_vm._v("attach")]
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.quickDownloads.length > 0
                    ? _c("div", { staticClass: "table_modul tabmobile_only" }, [
                        _c("table", { staticClass: "data_table_ty2" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "select_th",
                                  attrs: { colspan: "2" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selModelCd,
                                          expression: "selModelCd"
                                        }
                                      ],
                                      staticClass: "slt_white w100p",
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.selModelCd = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function($event) {
                                            return _vm.changeQdnModel()
                                          }
                                        ]
                                      }
                                    },
                                    _vm._l(_vm.quickDownloads, function(model) {
                                      return _c(
                                        "option",
                                        {
                                          key: model.BMODEL_ID,
                                          domProps: { value: model.BMODEL_ID }
                                        },
                                        [_vm._v(_vm._s(model.BMODEL_ID))]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.selModels, function(sub) {
                                return _c("tr", { key: sub.ID }, [
                                  _c("td", [_vm._v(_vm._s(sub.headNm))]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text_center" }, [
                                    sub.headId == "CNT_EXPVP"
                                      ? _c(
                                          "a",
                                          {
                                            attrs: { href: "JavaScript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.viewAttachFiles(
                                                  $event,
                                                  { BMODEL_ID: _vm.selModelCd }
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "em",
                                              { staticClass: "txt_point" },
                                              [_vm._v(_vm._s(sub.cntSum))]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    sub.headId != "CNT_EXPVP" && sub.cntSum > 0
                                      ? _c(
                                          "a",
                                          {
                                            attrs: { href: "JavaScript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.fileDownload(
                                                  sub.nIndex,
                                                  { BMODEL_ID: _vm.selModelCd }
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "em",
                                              { staticClass: "txt_point" },
                                              [_vm._v(_vm._s(sub.cntSum))]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    sub.headId != "CNT_EXPVP" && sub.cntSum == 0
                                      ? _c("span", [_vm._v(_vm._s(sub.cntSum))])
                                      : _vm._e()
                                  ])
                                ])
                              }),
                              _vm._v(" "),
                              _vm.selModelCd
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.BOM")))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text_center" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "ico_attach",
                                          attrs: { href: "JavaScript:" },
                                          on: {
                                            click: function($event) {
                                              return _vm.popupBomOpen({
                                                BMODEL_ID: _vm.selModelCd
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "sr_only" },
                                            [_vm._v("attach")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qcdnAttachFiles.length > 0
                    ? _c("div", { staticClass: "table_modul gridDown_wrap" }, [
                        _c("div", { staticClass: "gridtop_wrap" }, [
                          _c("em", { staticClass: "txt_info" }, [
                            _vm._v(
                              _vm._s(_vm.$t("MESSAGE.SEARCH.REQ.EXPLORER"))
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(1)
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "data_table_ty2" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION")))
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "pc_only" }, [
                                _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.WEB.VIEW")))
                              ]),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.PDF")))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "text_center" },
                            _vm._l(_vm.qcdnAttachFiles, function(file) {
                              return _c(
                                "tr",
                                { key: file.VERSION + file.BOM_VERSION },
                                [
                                  _c("td", [_vm._v(_vm._s(file.MODEL_CD))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(file.VERSION))]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "pc_only" }, [
                                    file.BOM_FILE_NAME
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "txt_link",
                                            attrs: { href: "JavaScript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.popupHtmlOpen(file)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("BUTTON.SEARCH.CLICK")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "txt_link",
                                        attrs: {
                                          href:
                                            "http://downloadcenter.samsung.com/content/" +
                                            file.PDF_PATH,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(file.PDF_FILE_NAME))]
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.quickDownloads && _vm.quickDownloads.length > 0
                    ? _c("div", { staticClass: "btn_wrap" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn_laodmore",
                            attrs: { href: "JavaScript:" },
                            on: {
                              click: function($event) {
                                return _vm.loadMoreSearch()
                              }
                            }
                          },
                          [
                            _vm._v(_vm._s(_vm.qcdnMoreMsg) + " "),
                            _c("em", [
                              _vm._v("("),
                              _c("i", [
                                _vm._v(_vm._s(_vm.quickDownloads.length))
                              ]),
                              _vm._v("/" + _vm._s(_vm.qcdnTotalCount) + ")")
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qcdnTotalCount == 0
                    ? _c("ul", { staticClass: "nodata_list" }, [
                        _c("li", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.viewName == "EM"
      ? _c("div", { staticClass: "contents_wrap" }, [
          _c("h2", { staticClass: "pg_title" }, [
            _vm._v(_vm._s(_vm.$t("TITLE.PRODUCT.INFO.EXPLODED.VIEW")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "srchTop_wrap srch_result mb-20" }, [
            _c("article", { staticClass: "srch_basic clear" }, [
              _c("dl", { staticClass: "dl_search w100p" }, [
                _c(
                  "dd",
                  {
                    staticClass: "clearable",
                    attrs: { "data-input-type": "input" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modelCode,
                          expression: "modelCode"
                        }
                      ],
                      ref: "modelCd",
                      staticClass: "text_input w100p",
                      attrs: {
                        type: "text",
                        placeholder: _vm.placeHolder,
                        maxLength: "20"
                      },
                      domProps: { value: _vm.modelCode },
                      on: {
                        keyup: [
                          _vm.onAutoCmpl,
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.onSearchExp(1)
                          }
                        ],
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.modelCode = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "clearable_clear" }, [_vm._v("X")])
                  ]
                ),
                _vm._v(" "),
                _c("dd", { staticClass: "btn" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_srch",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.onSearchExp(1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                  )
                ]),
                _vm._v(" "),
                _vm.searchMode == "1"
                  ? _c("dd", { staticClass: "auto" }, [
                      _c("article", { staticClass: "srch_more" }, [
                        _c("dl", { staticClass: "srch_autocomplete" }, [
                          _c("dd", [
                            _c(
                              "ul",
                              { staticClass: "scroll" },
                              _vm._l(_vm.autoCompletes, function(model) {
                                return _c(
                                  "li",
                                  {
                                    key: model.ID,
                                    class: { active: model.ID == _vm.modelCode }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "JavaScript:" },
                                        on: {
                                          click: function($event) {
                                            _vm.modelCode = model.ID
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(model.LABEL))]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid_wrap" },
            [
              _c("div", { staticClass: "grid_total" }, [
                _vm._v("Total Count : "),
                _c("em", [
                  _vm._v(_vm._s(_vm._f("numberFormat")(_vm.resultCount)))
                ])
              ]),
              _vm._v(" "),
              _c("toast-grid", {
                key: _vm.gridKey,
                ref: _vm.gridId,
                attrs: {
                  gridId: _vm.gridId,
                  columns: _vm.columns,
                  data: _vm.gridData,
                  options: _vm.options,
                  pageOptions: _vm.pageOptions,
                  isTotalCount: false,
                  click: _vm.contentClick
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.selModelCd && _vm.qcdnAttachFiles.length > 0
            ? _c("div", { staticClass: "gridDown_wrap" }, [
                _c("div", { staticClass: "table_modul gridDown_wrap" }, [
                  _c("div", { staticClass: "gridtop_wrap" }, [
                    _c("em", { staticClass: "txt_info" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.SEARCH.REQ.EXPLORER")))
                    ]),
                    _vm._v(" "),
                    _vm._m(3)
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "data_table_ty2" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.VERSION")))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "pc_only" }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.SEARCH.WEB.VIEW")))
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.SEARCH.PDF")))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "text_center" },
                      _vm._l(_vm.qcdnAttachFiles, function(file) {
                        return _c("tr", { key: file.VERSION }, [
                          _c("td", [_vm._v(_vm._s(file.MODEL_CD))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(file.VERSION))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pc_only" }, [
                            file.BOM_FILE_NAME
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "txt_link",
                                    attrs: { href: "JavaScript:" },
                                    on: {
                                      click: function($event) {
                                        return _vm.popupHtmlOpen(file)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BUTTON.SEARCH.CLICK"))
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "txt_link",
                                attrs: {
                                  href:
                                    "http://downloadcenter.samsung.com/content/" +
                                    file.PDF_PATH,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(file.PDF_FILE_NAME))]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "70%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn_wrap" }, [
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("Deju Vu")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/isoview7.cab",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("iso View")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn_wrap" }, [
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("Deju Vu")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn_white",
          attrs: {
            href: "http://skp.samsungcsportal.com/basis/page/isoview7.cab",
            title: ""
          }
        },
        [_c("i", { staticClass: "ico_down" }), _vm._v("iso View")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5ce15f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ce15f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/gspnCon/CommonConnect.vue
// module id = sqga
// module chunks = 0